import { action, observable, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'

import infoService from '@services/infoService'

export class ProductStore {

    @observable insuranceAgentProducts = []

    // Fetch insurance agent products and return raw results.
    @action
    getInsuranceAgentProductsData = async () => {
        try {
            const result = (await infoService.getProducts('insurance_agent')).data
            if (!result) return console.warn('no data for getInsuranceAgentProductsData')

            runInAction(() => {
                this.insuranceAgentProducts = result
            })
            return result
        } catch (error) {
            console.error('err getting getInsuranceAgentProductsData:', error)
            return null
        }
    }

    // Clear cached product lists.
    @action
    clearProductsData = async () => {
        this.insuranceAgentProducts = []
    }
}

export default remotedev(new ProductStore())
